/*
  Garment line item
  implemented: layout/theme.liquid, snippets\product-template.liquid, snippets\product-block-buy-buttons.liquid
*/
 document.addEventListener("DOMContentLoaded", function () {

     const line_item_facade = document.querySelector('[data-js-garment-line-item-facade]');
     const line_item_original = document.querySelector('[data-js-garment-line-item-orginal]');

     if(!line_item_original || !line_item_facade){
        return console.log('Cant find DOM elements for garment line item')
     }

     line_item_facade.addEventListener('change', (e)=>{
        line_item_original.value = e.target.value
     })


   
 })
